window.GACookieHandler = {
    /**
     * enable google analytic and load analytics-script
     *
     * https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
     */
    enableGoogleAnalyticsMeasurement: function () {
        window['ga-disable-' + window.gtmId] = false;
        // PREVENT multiple gtm.js pushes
        if (window.ga === undefined)
            this.initGoogleAnalyticsScript();
        
    },
    initGoogleAnalyticsScript: function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', window.gtmId);
    },
    /**
     * disable google analytics
     *
     * https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
     */
    disableGoogleAnalyticsMeasurement: function () {
        window['ga-disable-' + window.gtmId] = true;
        
    }
        
};
